import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getSupplierProductNoteListData } from './mockData'
import type { ISupplierProductNote } from '~/types/note/models'

export const {
  getNotes: getSupplierProductNotes,
  postNote: postSupplierProductNote,
  patchNote: patchSupplierProductNote,
  deleteNote: deleteSupplierProductNote,
  handlers,
} = makeNoteAPIs<ISupplierProductNote>({
  apiPathEntityNamePrefix: 'supplierproduct',
  getNoteListDataFn: getSupplierProductNoteListData,
})
